var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTappLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EC5F2A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13211_13595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9344 35.3333C21.0761 35.3333 17.9375 32.1681 17.9375 28.2769V14H23.3247V28.2769C23.3247 29.1723 24.0466 29.9003 24.9344 29.9003C25.8222 29.9003 26.5441 29.1723 26.5441 28.2769V25.8799H31.9313V28.2769C31.9313 32.1681 28.7927 35.3333 24.9344 35.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 18.1204H16V23.5534H32V18.1204Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13211_13595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 21.3333,
    fill: "white",
    transform: "translate(16 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTappLogo);
export default __webpack_public_path__ + "static/media/tapp-logo.58ebeea6ae65f53e16fcaf2b9356f963.svg";
export { ForwardRef as ReactComponent };